import React from 'react'

function TenderTextSwivelVAS() {
  return (
    <embed src="\pdfs\EAT1.5.4_VA-S_Swivel_displacement_outlet_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextSwivelVAS